import React, { useId } from "react";
import clsx from "clsx";

/**
 * Floating-label text input. Pass `label`; the placeholder is set to the label
 * so the CSS peer trick can animate it. Forwards any input props (type, value,
 * onChange, inputMode, disabled, required, ...).
 */
export const Input = ({ label, className, id, floatAlways = false, ...props }) => {
  const auto = useId();
  const fieldId = id || auto;
  return (
    <div className={clsx("field", className)}>
      <input id={fieldId} className="field-input peer" placeholder={label} {...props} />
      <label htmlFor={fieldId} className={clsx("field-label", floatAlways && "!top-1.5 !text-xs")}>
        {label}
      </label>
    </div>
  );
};

/** Floating-label select. The label always stays "up" (selects have no placeholder). */
export const Select = ({ label, className, id, children, ...props }) => {
  const auto = useId();
  const fieldId = id || auto;
  return (
    <div className={clsx("field", className)}>
      <select
        id={fieldId}
        className="field-input peer appearance-none bg-[length:1.25rem] bg-[right_0.75rem_center] bg-no-repeat pr-9"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2364748b' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'/%3E%3C/svg%3E\")",
        }}
        {...props}
      >
        {children}
      </select>
      <label htmlFor={fieldId} className="field-label !top-1.5 !text-xs">
        {label}
      </label>
    </div>
  );
};

/** Floating-label textarea. */
export const Textarea = ({ label, className, id, rows = 4, ...props }) => {
  const auto = useId();
  const fieldId = id || auto;
  return (
    <div className={clsx("field", className)}>
      <textarea id={fieldId} rows={rows} className="field-input peer resize-none" placeholder={label} {...props} />
      <label htmlFor={fieldId} className="field-label">
        {label}
      </label>
    </div>
  );
};
